<app-toolbar-shell class="toolbar-con">
  @if (loginService.isLogged()) {
  <kin-btn (onClick)="openRequiredEmailModal()"> exporter </kin-btn>
  @if (canManageGoal()) {
  <kin-btn (onClick)="openResetConfirmModal()" [disabled]="resetLoading()"> reset </kin-btn>
  }
  <kin-btn color="light" class="login-btn" (onClick)="openLogoutModal()">
    Se Deconnecter
  </kin-btn>
  } @else {
  <kin-btn class="login-btn" (onClick)="loginService.redirectToOauth()"> Se Connecter </kin-btn>
  }
</app-toolbar-shell>